import { Button, Grid, Typography } from "@material-ui/core";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { Table, TableBody, TableRow, TableCell } from "@material-ui/core";
import { Split } from "../../utils/Split";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useHistory } from "react-router";
import moment from "jalali-moment";
import useCustomState from "../../hooks/State";
import EditTypeModal from "./ModalEditType";
import { useMountAPI } from "../../hooks/APICall";
import Call from "../../service/API";
import {
  GREEN_PRIMRY,
  ERROR_COLOR,
  BLUE_COLOR,
  ORANGE_COLOR,
} from "../../utils/const";

const CounterTypeTableHeader = (props) => {
  const categories = useSelector((state) => state.categories);
  const counterTypeInfo = useCustomState({});
  const isLoading = useCustomState(true);
  const editCounterTypeModalOpen = useCustomState(false);

  const counterTypeUtils = {
    counterType: props.counterType,
    isLoading: isLoading,
    counterTypeInfo: counterTypeInfo,
  };

  useMountAPI(fetchCounterTypeInfo, counterTypeUtils);

  useEffect(() => {
    if (!isLoading.value) {
      const data = {
        name: counterTypeInfo.value?.water_meter_tag?.water_meter_tag_name,
        id: counterTypeInfo.value?.water_meter_tag?.water_meter_tag_id,
      };
      props.categoryInfoChanged(data);
    }
  }, [isLoading.value]);

  if (!isLoading.value) {
    const description =
      counterTypeInfo.value?.water_meter_type_other_information?.description;
    const counterTypeDescription = description ? description : "وارد نشده";
    const categoryStyle = {
      color: "#fff",
      backgroundColor: "green",
      fontSize: "12px",
      borderRadius: "4px",
      paddingRight: "6px",
      paddingLeft: "6px",
      marginRight: "8px",
    };
    if (
      counterTypeInfo.value?.water_meter_tag?.water_meter_tag_name.includes(
        "آب"
      )
    ) {
      categoryStyle.backgroundColor = BLUE_COLOR;
    } else if (
      counterTypeInfo.value?.water_meter_tag?.water_meter_tag_name.includes(
        "برق"
      )
    ) {
      categoryStyle.backgroundColor = ERROR_COLOR;
    } else {
      categoryStyle.backgroundColor = ORANGE_COLOR;
    }

    const category = (
      <span style={categoryStyle}>
        {convertNumbers(
          counterTypeInfo.value?.water_meter_tag?.water_meter_tag_name
        )}
      </span>
    );

    const cat = categories.filter(
      (c) =>
        c.name === counterTypeInfo.value?.water_meter_tag?.water_meter_tag_name
    );
    let unit = "";
    if (cat.length > 0) {
      unit = cat[0].units[cat[0].selectedUnitIdx];
    }

    return (
      <>
        <EditTypeModal
          open={editCounterTypeModalOpen}
          counterType={counterTypeInfo.value}
        />
        <Grid container>
          <Grid item sx={12} sm={12} md={7} lg={7}>
            <Grid align="center" item sx={12} sm={12} md={12} lg={12}>
              <div
                style={{
                  maxWidth: "820px",
                  marginTop: "48px",
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  paddingTop: "24px",
                  paddingBottom: "24px",
                  height: "380px",
                  overflow: "scroll",
                }}
              >
                <Typography style={{ fontSize: "24px" }}>
                  {convertNumbers(counterTypeInfo.value?.water_meter_type_name)}
                </Typography>
                <Table
                  style={{
                    backgroundColor: "#fff",
                    padding: "16px",
                    borderRadius: "12px",
                    marginTop: "8px",
                  }}
                  aria-label="simple table"
                >
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <Typography>ثبت شده در تاریخ</Typography>
                      </TableCell>
                      <TableCell align="center">
                        {convertNumbers(
                          moment(
                            counterTypeInfo.value?.water_meter_type_create_date
                          )
                            .locale("fa")
                            .format("YYYY/MM/DD")
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography>دسته</Typography>
                      </TableCell>
                      <TableCell align="center">{category}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography>تعداد پروژه ها</Typography>
                      </TableCell>
                      <TableCell align="center">
                        {convertNumbers(
                          counterTypeInfo.value?.All_project_with_this_type
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography>تعداد کنتورها</Typography>
                      </TableCell>
                      <TableCell align="center">
                        {convertNumbers(
                          counterTypeInfo.value?.All_counter_with_this_type
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <Typography>میزان مصرف این نوع</Typography>
                      </TableCell>
                      <TableCell align="center">
                        {convertNumbers(
                          counterTypeInfo.value?.all_consumptions_value_sum ===
                            undefined
                            ? 0
                            : counterTypeInfo.value?.all_consumptions_value_sum
                        ) +
                          " " +
                          unit}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </Grid>
          </Grid>

          <Grid
            style={{ paddingRight: "24px" }}
            align="center"
            item
            sx={12}
            sm={12}
            md={5}
            lg={5}
          >
            <div
              style={{
                maxWidth: "820px",
                height: "380px",
                marginTop: "48px",
                backgroundColor: "#fff",
                borderRadius: "12px",
                padding: "24px",
                overflow: "scroll",
                textAlign: "right",
              }}
            >
              <div style={{ height: "190px", overflow: "scroll" }}>
                <Typography
                  align="left"
                  style={{ fontSize: "16px", fontWeight: "bold" }}
                >
                  {"توضیحات نوع کنتور"}
                </Typography>
                <Typography align="left" style={{ fontSize: "14px" }}>
                  {counterTypeDescription}
                </Typography>
              </div>
              <hr />
              <Typography
                align="left"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                {"امکانات"}
              </Typography>
              <br />
              <Button
                onClick={() => editCounterTypeModalOpen.handleChange(true)}
                style={{
                  backgroundColor: "#ed6c02",
                  color: "#fff",
                  marginRight: "4px",
                  marginLeft: "4px",
                  marginBottom: "4px",
                }}
                variant="contained"
              >
                ویرایش نوع کنتور
              </Button>
              {/* <Button
                style={{
                  backgroundColor: "#d32f2f",
                  color: "#fff",
                  marginRight: "4px",
                  marginLeft: "4px",
                  marginBottom: "4px",
                }}
                variant="contained"
              >
                حذف نوع کنتور
              </Button> */}
            </div>
          </Grid>
        </Grid>
      </>
    );
  } else {
    return null;
  }
};

export default CounterTypeTableHeader;

const fetchCounterTypeInfo = (utils) => {
  const counterType = utils.counterType;
  const isLoading = utils.isLoading;
  const counterTypeInfo = utils.counterTypeInfo;

  const data = {
    water_meter_type_id: counterType,
  };

  Call("POST", "WaterMeterTypes/admin/getOne", data)
    .then((response) => {
      // console.log("fetch counter type info: ", response);
      if (response.data.code == 200) {
        counterTypeInfo.handleChange(response.data.data[0]);
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};
